import { render, staticRenderFns } from "./ClientsMailsPage.vue?vue&type=template&id=bdff91a0"
import script from "./ClientsMailsPage.vue?vue&type=script&lang=js"
export * from "./ClientsMailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports